import { collection, addDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { logError, logInfo } from '../utils/logger';

export const queueEmail = async (to, subject, data) => {
  try {
    const emailDoc = {
      to: [to.trim()],
      message: {
        subject,
        text: data.text || '',
        html: data.html || ''
      },
      template: data.template || null,
      template_data: data.variables || null,
      status: 'pending',
      attempts: 0,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString()
    };

    const docRef = await addDoc(collection(db, 'mail'), emailDoc);
    logInfo('Email queued successfully');
    return docRef.id;
  } catch (error) {
    logError('Failed to queue email:', error);
    throw error;
  }
};

export const sendSurveyCreatedEmail = async (survey) => {
  return queueEmail(survey.customerEmail, 'Survey Created', {
    template: 'SURVEY_CREATED',
    variables: {
      surveyName: survey.name,
      customerName: survey.customerName,
      surveyId: survey.id
    }
  });
};